import { Outlet } from 'react-router-dom'

import type { ReactElement } from 'react'

const Reviews = (): ReactElement => {
  return <Outlet />
}

export default Reviews
